import React, {useState, useReducer, useEffect} from "react";
import Icon from 'components/Safra/Icon';


import { ModalApp } from "components/Modal";
import Button from "components/Button";
import { useTranslation } from "contexts/Safra/TranslationContext";
import {
    trackOccupantsOpen,
    trackOccupantsChange,
    trackOccupantsComplete
} from "../../../../utils/analytics";


const ButtonSafra = React.lazy(() => import('components/Safra/Button'))

import { ContentRoom } from "./styles";

import { useApp } from "contexts/AppContext";
import { GuestsReducer } from "contexts/reducers/guests/reducers";
import { addAction, removeAction, increaseAgeAction, decreaseAgeAction } from "contexts/reducers/guests/actions";
import {
    changeGuestsAction,
    setTravellersHotelAction
} from "contexts/reducers/hotels/actions";
import {isChannel} from "../../../../utils";
import {useGenialApp} from "../../../../contexts/GenialAppContext";

const UserIcon = () => <Icon name="user" size={20} color="#4F4F4F" />;


export default function RoomQuantity() {
    const { t } = useTranslation();
    const { hotelState, hotelDispatch } =  !isChannel('genial') ? useApp() : useGenialApp()
    const { guestsSearchHotel, travellers } = hotelState
    const [ selectedButton, setSelectedButton] = useState('ll')

    const INITIAL_STATE_GUEST = {
        adults: guestsSearchHotel?.adults,
        children: guestsSearchHotel?.children,
        childrenInputAge: guestsSearchHotel?.childrenInputAge
    }

    const [open, setOpen] = useState(false);
    const [dataTravellers, setDataTravellers] = useState(travellers)

    const [guestsState, dispatch] = useReducer(
        GuestsReducer,
        INITIAL_STATE_GUEST
    )

    const { adults, children, childrenInputAge} = guestsState

    const maxPeople = 8;

    const maxAge = 17;

    const add = (type) => {
        if(dataTravellers.length >= maxPeople) {
            return
        }

        setDataTravellers([...dataTravellers, {
            "type": type,
            "firstName": "",
            "lastName": "",
            "birthDate": "",
            "gender": "",
            "document": ""
        }])

        dispatch(addAction(type))
        
        // Dispara evento GA4 quando quantidade aumenta
        const newTotal = dataTravellers.length + 1;
        const occupantType = type === 'adults' ? 'adult' : 'child';
        trackOccupantsChange('hotel', occupantType, newTotal, 'increase');
    }

    const remove = (type) => {

        let elementValue = document.getElementById("qtd_" + type).textContent

        if(dataTravellers.length === 1 || parseInt(elementValue) === 0) {
            return
        }

        setDataTravellers([...dataTravellers.filter((_,index) => index !== 0)])

        dispatch(removeAction(type))
        
        // Dispara evento GA4 quando quantidade diminui
        const newTotal = dataTravellers.length - 1;
        const occupantType = type === 'adults' ? 'adult' : 'child';
        trackOccupantsChange('hotel', occupantType, newTotal, 'decrease');
    }

    const increaseAge = (value, position) => {

        if (value >= maxAge) {
            return
        }

        dispatch(increaseAgeAction(position))
    }

    const decreaseAge = (position) => {
        dispatch(decreaseAgeAction(position))
    }

    const clearGuestsValidationError = () => {
        const container = document.getElementById('room-quantity-container');
        if (container) {
            const inputGroup = container.querySelector('.input-group');
            if (inputGroup) {
                inputGroup.classList.remove('validation-error');
            }
            const errorMsg = container.querySelector('.validation-error-message');
            if (errorMsg) {
                errorMsg.remove();
            }
        }
    }

    const handleModal = () => {
        hotelDispatch(changeGuestsAction(guestsState))
        hotelDispatch(setTravellersHotelAction(dataTravellers))
        
        if (adults + children > 0) {
            clearGuestsValidationError();
            // Dispara evento GA4 quando hóspedes são confirmados
            trackOccupantsComplete('hotel', adults, children, 0, adults + children);
        }
        
        setOpen(!open);
    };

    const InputControl = ({type, placeholder, subtitle, value = null}) => {
        return (
            <div style={{display: 'flex', flexDirection: 'column', gap: '12px', width: '100%', textAlign: 'left'}}>
                <div style={{display: 'flex', flexDirection: 'column', gap: '4px', textAlign: 'left'}}>
                    <span style={{fontFamily: 'var(--font-family-base)', fontSize: '16px', fontWeight: 600, color: 'var(--primary-color)', textAlign: 'left'}}>{placeholder}</span>
                    <span style={{fontFamily: 'var(--font-family-base)', fontSize: '14px', fontWeight: 400, color: 'var(--primary-color)', textAlign: 'left'}}>{subtitle}</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                    <span role="button" onClick={() => remove(type)}>
                        <Icon name="circle-minus" style={{width: '28px', height: '28px', color: 'var(--primary-color)'}}/>
                    </span>
                    <span style={{fontFamily: 'var(--font-family-base)', fontSize: '18px', fontWeight: 500, color: 'var(--primary-color)', textAlign: 'center'}}>
                        {value}
                    </span>
                    <span role="button" onClick={() => add(type)}>
                        <Icon name="circle-plus" style={{width: '28px', height: '28px', color: 'var(--primary-color)'}}/>
                    </span>
                </div>
            </div>
        )
    }

    const InputControlAge = ({placeholder, value = null, position}) => {
        return (
            <div style={{display: 'flex', alignItems: 'center', gap: '12px', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, textAlign: 'left'}}>
                    <span style={{fontFamily: 'var(--font-family-base)', fontSize: '14px', fontWeight: 600, color: 'var(--primary-color)'}}>
                        {t('safra.components.room_quantity.child_age', { index: position + 1 })}
                    </span>
                    <span style={{fontFamily: 'var(--font-family-base)', fontSize: '12px', fontWeight: 400, color: 'var(--primary-color)'}}>
                        {t('safra.components.room_quantity.checkin_day')}
                    </span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '16px'}}>
                    <button
                        type="button"
                        onClick={() => decreaseAge(position)}
                        style={{
                            width: '36px',
                            height: '36px',
                            border: 'none',
                            background: 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            padding: 0,
                            color: 'var(--primary-color)'
                        }}
                    >
                        <Icon name="circle-minus" size={28} />
                    </button>
                    <span style={{
                        fontFamily: 'var(--font-family-base)',
                        fontSize: '16px',
                        fontWeight: 600,
                        color: 'var(--primary-color)',
                        minWidth: '24px',
                        textAlign: 'center'
                    }}>
                        {value}
                    </span>
                    <button
                        type="button"
                        onClick={() => increaseAge(value, position)}
                        style={{
                            width: '36px',
                            height: '36px',
                            border: 'none',
                            background: 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            padding: 0,
                            color: 'var(--primary-color)'
                        }}
                    >
                        <Icon name="circle-plus" size={28} />
                    </button>
                    <span style={{fontFamily: 'var(--font-family-base)', fontSize: '14px', fontWeight: 400, color: 'var(--primary-color)'}}>
                        {t('safra.common.years')}
                    </span>
                </div>
            </div>
        )
    }

    useEffect(() => {
        var channel = localStorage.getItem('channel');

        setSelectedButton(channel)
    })

    const totalGuests = adults + children;
    const hasGuests = totalGuests > 0;
    const guestsLabel = totalGuests > 1 
        ? `${totalGuests} ${t('safra.components.search_bar.guests')}` 
        : `${totalGuests} ${t('safra.components.search_bar.guest')}`;

    return (
        <div className="content-custom" id="room-quantity-container">
            <span id="qtd_adults" style={{ display: 'none' }}>{adults}</span>
            <span id="qtd_children" style={{ display: 'none' }}>{children}</span>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    width: '100%',
                    minHeight: '62px',
                    padding: '16px',
                    border: '1px solid #D8D8D8',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    position: 'relative'
                }}
                onClick={() => {
                    trackOccupantsOpen('hotel');
                    handleModal();
                }}
            >
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 2px', minWidth: '20px', minHeight: '20px', color: '#4f4f4f' }}>
                    <UserIcon />
                </span>
                <div style={{ display: 'flex', flexDirection: 'column', gap: hasGuests ? '4px' : '0px', flex: 1, minWidth: 0 }}>
                    {hasGuests && (
                        <label
                            style={{
                                color: '#4F4F4F',
                                letterSpacing: '-0.8px',
                                margin: 0,
                                lineHeight: '1',
                                fontSize: '12px',
                                fontFamily: 'var(--font-family-base)',
                                fontWeight: 400
                            }}
                        >
                            {t('safra.components.room_quantity.title')}
                        </label>
                    )}
                    <span
                        style={{
                            fontSize: '14px',
                            fontWeight: hasGuests ? 600 : 400,
                            fontFamily: 'var(--font-family-base)',
                            color: '#4F4F4F',
                            lineHeight: '1'
                        }}
                    >
                        {hasGuests ? guestsLabel : t('safra.components.room_quantity.title')}
                    </span>
                </div>
            </div>

            <ModalApp show={open} handleModal={handleModal} label={t('safra.components.room_quantity.title')} subtitle={t('safra.components.room_quantity.subtitle')} customHeader={true}>

                {/* Conteúdo */}
                <div style={{padding: '24px', display: 'flex', flexDirection: 'column', gap: '24px', textAlign: 'left'}}>
                    <InputControl 
                        placeholder={t('safra.components.room_quantity.adults.label')} 
                        subtitle={t('safra.components.room_quantity.adults.subtitle')} 
                        type="adults" 
                        value={adults} 
                    />
                    <InputControl 
                        placeholder={t('safra.components.room_quantity.children.label')} 
                        subtitle={t('safra.components.room_quantity.children.subtitle')} 
                        type="children" 
                        value={children} 
                    />

                    { childrenInputAge?.length > 0 && (
                        <div style={{borderTop: '1px solid #f4f4f4', paddingTop: '24px', display: 'flex', flexDirection: 'column', gap: '24px'}}>
                            { childrenInputAge.map((item, i) =>
                                <InputControlAge
                                    key={i}
                                    placeholder={`Criança ${i + 1}`}
                                    value={item.age}
                                    position={i}
                                />
                            )}
                        </div>
                    )}
                </div>

                <div className="custom-modal-footer">
                    {(selectedButton === 'safra' || selectedButton === 'encantech-shop') &&
                        <>
                            <ButtonSafra type="button" width="200px" onClick={ handleModal }>{t('safra.common.save')}</ButtonSafra>
                        </>
                    }
                    {selectedButton === 'll' &&
                        <>
                            <Button type="button" width="200px" onClick={ handleModal }>{t('safra.common.continue')}</Button>
                        </>

                    }
                </div>
            </ModalApp>
        </div>
    );
}